import { Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AuthService } from "./services/auth/auth.service";
import { MenuService } from "./services/menu/menu.service";

@Component({
  selector: "app-root",
  standalone: true,
  template: ` <router-outlet /> `,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);
  private menuService = inject(MenuService);

  ngOnInit(): void {
    // Covers the "already logged in, tab reopened/refreshed" case — a fresh
    // login schedules its own timer via storeLoggedInStaffDetails().
    this.authService.scheduleAutoLogout();

    // Permissions are resolved fresh on every backend request now rather than
    // being frozen into the login token — so the roles/permissions cached from
    // login can be stale (e.g. after a role change) until this re-checks.
    // SidebarComponent's own initialiseProducts() call (in its constructor) runs
    // synchronously off whatever's cached right now, so without rebuilding the
    // menu again once this resolves, a role change wouldn't be reflected in the
    // sidebar until a second refresh.
    this.authService.refreshPermissions().subscribe(() => {
      this.menuService.initialiseProducts();
    });
  }
}
